import React from 'react';
import { back, chevron_right, gear } from '../../Images/Icons';
import { useNavigate } from 'react-router-dom';
import { View } from '../../Components';

const SettingsPage = () => {

    const navigation = useNavigate();

    const onGoback = () => {
        navigation(-1);
    }

    const onChangePassword = () => { navigation('/profile/settings/changepassword') }

    const onPrivacyPolicy = () => {
        navigation('/profile/settings/privacypolicy')
    }

    return (
        <div>
            <div class="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Settings</div>
                </div>
            </div>
            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: '#F2F5FA' }}>
                <div style={{ margin: 20 }}>
                    <View onClick={onChangePassword} justifyContent="space-between" style={{ height: 48, marginTop: 20, background: 'white', borderRadius: 12, padding: '0 16px', cursor: 'pointer' }}>
                        <div style={{ fontSize: 14, fontWeight: 500, color: '#3C3E42' }}>Change Password</div>
                        <div><img id="svg-grey" src={chevron_right} alt="" style={{ width: 24, height: 24 }} /></div>
                    </View>
                    <View onClick={onPrivacyPolicy} justifyContent="space-between" style={{ height: 48, marginTop: 16, background: 'white', borderRadius: 12, padding: '0 16px', cursor: 'pointer' }}>
                        <div style={{ fontSize: 14, fontWeight: 500, color: '#3C3E42' }}>Privacy Policy</div>
                        <div><img id="svg-grey" src={chevron_right} alt="" style={{ width: 24, height: 24 }} /></div>
                    </View>
                </div>
                <View >
                    <div style={{
                        width: 138, height: 44, display: 'flex', justifyContent: 'center',
                        fontSize: 16, fontWeight: 700, marginBottom: 40,
                        alignItems: 'center', color: '#fc3c3c', border: 'solid 1px #CAD2DF', borderRadius: 8, cursor: 'pointer'

                    }}
                        onClick={() => {
                            localStorage.clear();
                            navigation('/login');
                        }}
                    >
                        Log Out
                    </div>
                </View>
            </div>
        </div>
    )
}

export default SettingsPage